import { motion, useScroll, useSpring, useReducedMotion } from 'framer-motion';

/**
 * ScrollProgress — 2px coral hairline pinned to the top of the viewport.
 *
 * Scales horizontally from 0 to 1 as the user scrolls the page. The
 * spring smooths Lenis hand-off so the bar doesn't tick. Reduced-motion
 * users get a static, instantly-correct bar (no spring jitter).
 */
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const reduced = useReducedMotion() ?? false;
  const scaleX = useSpring(scrollYProgress, {
    stiffness: reduced ? 1000 : 220,
    damping: reduced ? 100 : 32,
    mass: 0.4,
  });

  return (
    <motion.div
      aria-hidden
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 2,
        background: 'var(--accent)',
        transformOrigin: 'left',
        scaleX,
        zIndex: 100,
        pointerEvents: 'none',
        boxShadow: '0 0 8px var(--accent-glow)',
      }}
    />
  );
}
